
<!-- TODO MBO en attente retour AIFE champs nature Marche -->
<!-- <app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"

	[value]="radioButtonValue"

	[label]="step2.getspan4"
	[type]="'radio'"
	[rule]="'required'"
	[errorMessage]="{'required' : 'ctr_1094_HorsDef'}"
	[radios]="[
		{
			label: step2.gettravaux,
			value: travauxValue
		},
		{
			label: step2.getfournitures,
			value: fournituresValue
		},
		{
			label: step2.getservices,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input> -->

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="rectificatif?.objet"
[label]="step2.getobjet"
[type]="'text'" [rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_107', 'minLength' : 'ctr_123'}"
[name]="getUid()+'_SepAtt_objet'">
</app-form-input>

<span class="d-block" >{{ step2.getspan4 | translate }}</span>

<app-type-lieu [uid]="'lieuExecutionLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_43'}"
 [lieuExecutionLivraison]="rectificatif?.lieuExecutionLivraison"></app-type-lieu>
 <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>


<!---->

<app-type-objCPV  [uid]="getUid()" [parentForm]="parentForm" [cpv]="rectificatif?.description?.cpv"></app-type-objCPV>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="rectificatif?.typeProcedure"
[label]="step2.getprocedure"
[type]="'text'"
[name]="getUid()+'_SepAtt_procedure'">
</app-form-input>

